import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../../app/store";
import { PayloadMessage } from "../../model/payload-message";
export interface MessagesState {
  array: PayloadMessage[];
  history: PayloadMessage[];
}

const initialState: MessagesState = {
  array: [],
  history: [],
};

export const messagesSlice = createSlice({
  name: "messages",
  initialState: initialState,
  reducers: {
    sendMessage: (
      state: MessagesState,
      action: PayloadAction<PayloadMessage>
    ) => {
      state.array = [...state.array, action.payload];
    },
    clearMessages: (state: MessagesState) => {
      state.array = [];
    },
    clearHistory: (state: MessagesState) => {
      state.history = [];
    },
    updateHistory: (
      state: MessagesState,
      action: PayloadAction<PayloadMessage[]>
    ) => {
      if (state.history.length > 1) {
        state.history = [
          ...action.payload.slice(0, -state.history.length),
          ...state.history,
        ];
      } else {
        state.history = action.payload;
      }
    },
  },
});

export const { updateHistory, sendMessage, clearMessages, clearHistory } =
  messagesSlice.actions;

export const selectMessages = (state: RootState) => state.messages.array;
export const selectHistory = (state: RootState) => state.messages.history;

export default messagesSlice.reducer;
